import React from 'react';
import { useRouter } from 'next/router';
import finsightWebUrl from '@/finsight/infrastructure/finsightWebUrl';
import usersUrl from '@/users/infrastructure/usersUrl';
import Modal from '@dealroadshow/uikit/core/components/Modal';
import Button, { ButtonVariantType } from '@dealroadshow/uikit/core/components/Button';
import { UserPlanType } from '@/users/domain/UserPlan';
import config from '@/Framework/config';

import finsightLogo from '@/Framework/assets/logo/finsightLogo.inline.svg';
import styles from './styles.scss';

const TEXT_CONTENT = {
  [UserPlanType.PRO]: {
    name: 'Professional',
    description: 'Everything on Premium, plus exclusive access to our award-winning BWIC & Inventory Monitor, TRACE, Portfolio Monitor, and Bond Screener modules.',
  },
  [UserPlanType.PREMIUM]: {
    name: 'Premium',
    description: 'Unlimited access to new issue deal data, visualizations, league tables, rating agency research reports, and more.',
  },
};

interface IProps {
  plan: UserPlanType,
  isVisible: boolean,
  onClose: () => void,
}

const LoginModal = ({
  plan,
  isVisible,
  onClose,
}: IProps) => {
  const {
    replace,
    asPath,
  } = useRouter();
  const {
    name = '',
    description = '',
  } = TEXT_CONTENT[plan] || {};
  const tenant = config.tenant.finsight.code;

  const onLogin = () => {
    const callbackUrl = finsightWebUrl.getPropagateCallbackUrl(asPath);
    const url = usersUrl.getLoginUrl(callbackUrl, tenant);

    replace(url);
  };

  return (
    <Modal
      showOverlay
      isVisible={ isVisible }
      closeOnEsc={ false }
      hideOnOverlayClicked={ false }
      showCloseButton
      usePortal={ false }
      dataTest="pricingLoginModal"
      onCloseClicked={ onClose }
      className={ styles.loginModal }
    >
      <div className={ styles.loginModalContent }>
        <div className={ styles.loginModalLogo }>
          <i dangerouslySetInnerHTML={ { __html: finsightLogo } } />
        </div>

        <div className={ styles.loginModalTextContent }>
          <div className={ styles.loginModalTitle }>
            { `Upgrade your plan to ${ name }` }
          </div>

          <div className={ styles.loginModalDescription }>
            { description }
          </div>
        </div>

        <Button
          variant={ ButtonVariantType.firm }
          title="Log in with FINSIGHT to Upgrade"
          dataTest="pricingLoginModalButton"
          onClick={ onLogin }
        />
      </div>
    </Modal>
  );
};

export default LoginModal;
